import React from "react";
import "../style/debtDetails.css";
import bagImage from "../../../../assets/images/debtPayoff/bag.png";
import { Progress } from "antd";

export const DebtAmortization = (props) => {
  const detailsData = [
    {
      id: 1,
      name: "Car",
      time: "Auto",
    },
  ];
let percentageValue= (((props.totalPaid && props.totalPaid )/ (props.data && props.data["Initial Loan Amount"]) ) * 100).toFixed(2);
console.log("percentageValue",percentageValue)
  return (
    <div>
      {" "}
      <div className="cardHeadingDebt">Amortization</div>
      <div className="listingContainer">
        <React.Fragment>
          {props.data &&  props.data.module ? (
              <div className="list-row-no">
                <div className="listname-dark">
                  <div style={{ fontSize: "16px", fontWeight: "bold" }}>
                    {props.data && props.data["Nickname of Liabilities"] && props.data["Nickname of Liabilities"] }
                  </div>
                  <div style={{ fontWeight: "400" }}>{props.data && props.data.module && props.data.module}</div>
                </div>
                <div>
                  <img src={bagImage} alt="bag"></img>
                </div>
              </div>
          ) : (
            <div className="nodata">No data to show</div>
          )}
          
          <Progress
            strokeColor={"#2a3da3"}
            percent={percentageValue}
            style={{ marginTop: "5rem", width:"95%" }}
            status="active"
          />
        </React.Fragment>
      </div>
    </div>
  );
};
